const language = Object.create(null)
require.context('@/language', false, /\.js$/).keys().forEach(fileName => {
  const name = fileName.slice(2, -3)
  if (name !== 'index') language[name] = require(`${fileName}`).default
})
export default language
